import './spinner.scss';
import { ClassNameSpinner, SpinnerProps } from './types/spinnerProps';

const Spinner = (props: SpinnerProps) => {
    const spinnerClass = props.spinnerClass ? props.spinnerClass : ClassNameSpinner.Big;
    if (props.isMist) {
        return <div className='mist-spinner'><div className={`spinner ${spinnerClass}`}></div></div>;
    }
    return <div className={`spinner ${spinnerClass}`}></div>
}

export default Spinner;